module.exports = __webpack_public_path__ + "static/media/construction.882ad089.svg";